import type {BrowserAuthOptions} from '@azure/msal-browser';

export function makeAzureScope(scope: string, tenant: string): string {
  return `https://${tenant}.onmicrosoft.com/${scope}`;
}

export function makeAzureAuthOptions(
  clientId: string,
  tenant: string,
  policy: string
): Pick<BrowserAuthOptions, 'clientId' | 'authority' | 'knownAuthorities'> {
  return {
    clientId: clientId,
    authority: `https://${tenant}.b2clogin.com/${tenant}.onmicrosoft.com/${policy}`,
    knownAuthorities: [`${tenant}.b2clogin.com`],
  };
}
